export const choose = creative => {
  switch (creative.action) {
    case 'banner': {
      if (creative.moatUrl) {
        return 'moatBuilder';
      } else {
        return 'bannerBuilder';
      }
    }
    case 'outstream':
      return 'outstreamBuilder';
    case 'hosted-video':
      return 'nativeOutstream';
    case 'instream-video':
      return 'instreamVideo';
    default:
      return 'defaultBuilder';
  }
};
